/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation400,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryResponse,
} from "../../types/individualPaymentRenegotiationController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation.ts";
import { individualPaymentRenegotiationViewModelSchema } from "../individualPaymentRenegotiationViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryParamsSchema =
  z
    .object({
      parcels: z.optional(z.array(z.coerce.number().int())),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation200Schema =
  z.lazy(
    () => individualPaymentRenegotiationViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation200>;

/**
 * @description Parcela já em renegociação pendente
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation400Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiation200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationQueryResponse>;
